const normalizeMessageId = (value) => String(value ?? "").trim().toLowerCase();

export const hasChatMessageId = (messages, messageId) => {
  const normalizedMessageId = normalizeMessageId(messageId);
  if (!normalizedMessageId || !Array.isArray(messages)) return false;

  return messages.some(
    (message) => normalizeMessageId(message?.id) === normalizedMessageId,
  );
};

export const shouldUploadChatMessageToBatch = ({
  existingMessages,
  messageId,
} = {}) => !hasChatMessageId(existingMessages, messageId);
